<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
      <Dialog
      :visible.sync="printDialog"
      header="Do you want to print this bill?"
      :style="{width: '35vw'}"
      :modal="true"
      >
      <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-success" @click="printBill" label="Yes" icon="pi pi-check"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-danger" @click="closePrintDialog" icon="pi pi-times" label="No"/>
          </div>
         </div>
      </Dialog>

        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="transactionDate">Date</label>
                <date-picker  ref="tran" v-model="transactionDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" type="text" ref="tran" v-else class="nepali-calendar form-control" id="transactionDate" v-model="transactionDate"/>
               </div>
               <div class="col-md-2">
                <label for="transactionDate">Purchase Date</label>
                <date-picker v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
               </div>

              <div class="p-field p-col-12 p-md-2">
              <label for="billNo" >Bill No</label>
                <InputText id="billNo" v-model="billNo" disabled/>
              </div>
             <div class="p-field p-col-12 p-md-2">
                <label for="refno" >Ref. No.</label>
                <InputText id="refno" v-model="refNo" />
             </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="purType">Pur Type</label>
                <select class="form-control " v-model="taxType">
                  <option selected disabled value="">Select One</option>
                  <option  v-for="(tax,ind) in taxTypeList" :key="ind">{{tax.name}}</option>
                </select>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <!-- <div class="p-field p-col-12 p-md-3">
                  <label for="loadFrom">Load From</label>
                  <label class="radio-inline"  ><input type="radio" v-model="loadType" name="order" value="order" @change="loadFrom(loadType)"/>Order</label>
                  <label class="radio-inline" ><input type="radio" v-model="loadType" name="challan" value="challan" @change="loadFrom(loadType)"/>Challan</label>
              </div>
              <div class="p-field p-col-12 p-md-2" v-if="loadFromOrder && !this.editing">
                <label for="OrderList" v-if="loadFromOrder && !this.editing"> Order List</label>
                <Dropdown
                  v-model="orderId"
                  :options="orderIdList"
                  optionLabel="orderNo"
                  :filter="true"
                  @change="loadPurchaseDataWithOrderId(orderId.orderNo)"
                  placeholder="Select Item"
                />
              </div>
              <div class="p-field p-col-12 p-md-2" v-if="loadFromChallan && !this.editing">
                <label for="ChallanList" v-if="loadFromChallan && !this.editing"> Challan List</label>
                <Dropdown
                  v-model="challanId"
                  :options="challanIdList"
                  optionLabel="challanNo"
                  :filter="true"
                  @change="loadPurchaseDataWithChallanId(challanId.challanNo)"
                  placeholder="Select Item"
                />
              </div> -->
              <div class="p-field p-col-12 p-md-2">
              <label for="purType">Manual Entry</label>
               <Checkbox v-model="dairyManualEntry" :binary="true" />
               </div>
            </div>
            <!-- <div class="p-fluid p-formgrid p-grid p-mt-2">
               
            </div> -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-3">
                  <label>Supplier Type</label>
                  <Dropdown
                    v-model="supplierType"
                    :options="supplierTypeList"
                    optionLabel="label" optionValue="value"
                    :filter="true"
                    placeholder="Select Type"
                    :showClear="true"
                  />
            </div>
            <div class="p-field p-col-12 p-md-3">
                  <label>Shift</label>
                  <Dropdown
                    v-model="shift"
                    :options="shiftList"
                    optionLabel="label" optionValue="value"
                    :filter="true"
                    placeholder="Select Shift"
                    :showClear="true"
                  />
            </div>
<!--            {{cashTransactionMaster}}-->
              <div class="p-field p-col-12 p-md-2">
                <label for="warehouse">Store</label>
                <Dropdown
                  v-if="!setWarehouseData"
                  v-model="warehouse"
                  :options="warehouseLists"
                  optionLabel="name"
                  :filter="true"
                  placeholder="Select store"
                  :showClear="true"
                />
                <Dropdown
                  v-else
                  v-model="warehouse"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>
              <wearhouseDialog class="p-mt-5"  style="margin-right: -10em;" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="!ifNotCash">
              <div class="p-field p-col-12 p-md-2" v-if="accountMaster.id > 0">
                  <label for="panNo">Tax No:</label>
                  <b style="margin-right:10px">{{accountMaster.panNo}}</b>
                  <label for="panNo">Cur. Bal:</label>
                  <b style="color:red;" v-if="accountMaster.closingBalance>0">
                    {{(accountMaster.closingBalance).toFixed(2) + 'Cr'}}
                  </b>
                  <b style="color:green;" v-else>
                    {{(accountMaster.closingBalance *(-1)).toFixed(2) + 'Dr'}}
                  </b>
                </div>
            </div>

            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="itm" >Item<span style="color:red">*</span></label>

                <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
              </div>
              <itemDialog class="p-mt-5" style="margin-right: -10em;" v-tooltip.top="'Add Item'"
              @set_data_item="set_data_item"/>
              <div class="p-field p-col-12 p-md-2">
                <label for="qty">Quantity</label>
                <!-- <input type="text" class="form-control" id="qty" @keypress="isNumber(event)" v-model="quantity"/> -->
                <InputNumber id="qty" v-model="quantity" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="unit">Unit</label>
                <InputText id="unit" v-model="items.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="rate">Rate</label>
                <!-- <input type="text" class="form-control" id="rate" @keypress="isNumber(event)"  v-model="rate"/> -->
              <InputNumber id="rate" v-model="rate" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''"   :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="total">Total</label>
                <!-- <input class="form-control" id="total"  @keypress="isNumber(event)"  v-model="total"/> -->
              <InputNumber disabled  id="total" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="total"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

              <!-- <label  for="act">Action</label> -->
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-rounded" @click.prevent="addItemToDTOList" :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-rounded"  @click.prevent="openBasicBatchDetails" label="Details"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-danger" v-if="editDTO" @click="itemDTOreset" label="Cancel"/>
              </div>

            </div>
            <div style="display:none">{{findRate}}</div>
            <div style="display:none" > {{totalAmount}}</div>
            <div style="display:none">{{setRateFromItem}}</div>
            <!-- <div class="form-group container" v-show="items.closingStock>=0"> -->
              <div class="p-field p-col-12 p-md-2">
                <label  for="avl">Cur. Stock:</label>
                <b>{{items.closingStock}}</b>
              </div>
              <div v-if="dairyManualEntry" class="p-fluid p-formgrid p-grid">
          <!-- <div class="p-field p-col-12 p-md-2">
              <label for="name">Water Mix %<span style="color:red">*</span></label>
                <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="waterMixPercentage"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div> -->
            <div class="p-field p-col-12 p-md-2">
              <label for="shortName">FAT %</label>
              <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="fatPercentage"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="manufactureDate">FAT Rate</label>
               <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="fatRate"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="expiryDate">SNF %</label>
                <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="snfPercentage"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="shortName">SNF Rate</label>
              <InputNumber   id="free" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="snfRate"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="ccPercentage">TS %</label>
              <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="tsPercentage"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="ccPercentage">TS Rate</label>
              <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="tsRate"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="ccPercentage">Rate Adjust</label>
              <InputNumber   id="ccPercentage" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="rateAdjustment"  :minFractionDigits="2" :maxFracionDigits="4" />
            </div>
            
           </div>

            <div v-if="!dairyManualEntry" class="p-fluid p-formgrid p-grid">
            <!-- <div v-if="supplierType == 'Kishan'"> -->
 <div class="p-field p-col-12 p-md-2" v-if="supplierType == 'Kishan'">
          <a style="font-size: 18px" download="milkSupplierKishan.xlsx"
             href="../../../../static/excelFormat/milkSupplierKishan.xlsx">Download Format</a>
        </div>
        <div class="p-field p-col-12 p-md-2" v-if="supplierType == 'Kishan'">
        <input type="file" @change="onFileChange" />
        </div>
            <!-- </div> -->


 <div class="p-field p-col-12 p-md-2" v-if="supplierType == 'Sanstha'">
          <a style="font-size: 18px" download="milkSupplierSanstha.xlsx"
             href="../../../../static/excelFormat/milkSupplierSanstha.xlsx">Download Format</a>
        </div>
        <div class="p-field p-col-12 p-md-2" v-if="supplierType == 'Sanstha'">
        <input type="file" @change="onFileChangeSanstha" />
        </div>
        <div class="p-field p-col-12 p-md-3" v-if="this.$store.getters.modules.includes('5.31')">
            <Button id="imageUpload" @click.prevent="showItemUpload" class="p-button-raised"
                    label="Upload Image"/>
          </div>
          <!-- <div class="p-field p-col-12 p-md-3">
            <Button :disabled="!this.imageList.length >0" id="viewImage" @click.prevent="viewImage" label="View Image"
                    class="p-button-raised"/>
          </div> -->
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
              <div class="scrollable">
                  <table class="table table-bordered">
                    <thead >
                      <tr>
                        <th scope="col">SN</th>
                        <th scope="col">Item Name</th>
                        <th scope="col">Name</th>
                        <th scope="col">Qty (Ltr)</th>
                        <th scope="col">Fat %</th>
                        <th scope="col">Fat</th>
                        <th scope="col">Snf %</th>
                        <th scope="col">Snf</th>
                         <th scope="col" v-if="supplierType == 'Sanstha'">Ts %</th>
                        <th scope="col" v-if="supplierType == 'Sanstha'">Ts</th>
                        <th scope="col">Extra</th>

                        <th scope="col">Rate</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>

                    <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index" >
                      <tr>
                        <td>{{index+1}}</td>
                        <td>{{item.itemMaster.name}}</td>
                        <td>{{item.supplierName}}</td>
                        <td style="text-align:right">{{item.quantity}}</td>
                        <td style="text-align:right">{{item.fatPercentage}}</td>
                        <td style="text-align:right">{{item.fatAmount}}</td>
                        <td style="text-align:right">{{item.snfPercentage}}</td>
                        <td style="text-align:right">{{item.snfAmount}}</td>
                        <td style="text-align:right" v-if="supplierType == 'Sanstha'">{{item.tsPercentage}}</td>
                        <td style="text-align:right" v-if="supplierType == 'Sanstha'">{{item.tsAmount}}</td>
                        <td style="text-align:right">{{item.rateAdjustment}}</td>
                        <td style="text-align:right">{{item.rate}}</td>
                        <td style="text-align:right">{{(item.rate * item.quantity).toFixed(4)}} </td>
                        <td style="text-align:center">
                        <Button class="p-button-raised p-button-success"
                         @click="editItemFromDTO(item,index)" icon="pi pi-pencil"/>
                        <Button class="p-button-raised p-button-danger"
                         v-if="editDTO" @click="removeItemFromDTO(item, index)"
                        disabled icon="pi pi-trash"/>
                        <Button class="p-button-raised p-button-danger"
                        v-else-if="!editDTO" @click="removeItemFromDTO(item, index)"
                        icon="pi pi-trash"/>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
            <hr>
              <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-2">
                    <b style="margin-left: 15em;">Total:</b>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <b style="margin-left: 16em;">{{totalQty}}</b>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <b style="margin-left: 38em;">{{subTotal.toFixed(4)}}</b>
                  </div>
                </div>
                <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <textarea type="text" rows="6" class="form-control"  v-model="narration"/>
         </div>
        <!-- <div class="p-field p-col-12 p-md-6">
         <table style="border: 1px solid #c8c8c8;">
            <thead >
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Subtotal </th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{subTotal.toFixed(4)}}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Discount </th>
                <Button v-if="chooseDiscountAmt" @click="chooseDisountAmt" label="Rs"/>
                <Button v-if="chooseDiscountPer" @click="chooseDisPercent" label="%"/>
              <td style="border: 1px solid #c8c8c8;padding: 0px 0em 0px;">
                <InputText onfocus="if (this.value === '0')
                      this.value = ''" v-if="chooseDiscountPer" v-model="discountPer"
                                      placeholder="discountPer"/>
                <InputText onfocus="if (this.value === '0')
                                  this.value = ''" v-if="chooseDiscountAmt" v-model="discountAmt" placeholder="discountamt"/>
              </td>
            </tr>
            <tr >
               <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Discounted Amt: </th>
               <th></th>
               <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{discountAmt}}</td>
           </tr>
             <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Excise Duty </th>
                <InputText onfocus="if (this.value === '0')
                                  this.value = ''" v-model="exciseDuty"/>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{exciseDuty}}</td>
            </tr>
             <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Taxable </th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{taxable.toFixed(4)}}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Non-taxable </th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{nonTaxable.toFixed(4)}}</td>
             </tr>


            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Tax </th>
              <th>13%</th>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{tax.toFixed(4)}}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Total </th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{totalBillAmount.toFixed(4)}}</td>
            </tr>
          </thead>
        </table>
      </div> -->
      <!-- <div class="p-field p-col-12 p-md-2">
        <form>
          <label>Extra Expenses:</label>
          <Button class="p-button-raised p-button-rounded"  @click.prevent="openBasic" icon="pi pi-plus"/>
          <Dialog header="Extra Expenses" :visible.sync="displayBasic"
           :style="{width: '75vw', height:'20vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
          <form>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="extraExpense">Extra Expenses Name</label>
                  <Dropdown
                  v-model="extraExpenses"
                  :options="extraExpensesList"
                  optionLabel="expensesName"
                  :filter="true"
                  placeholder="Select Expenses"
                  id="extraExpense"
                  :showClear="true"
                />
             </div>
             <extraExpensesDialog class="p-mt-5"  style="margin-right: -10em;" v-tooltip.top="'Add Extra Expenses'"/>
             <div class="p-field p-col-12 p-md-1">
               <label for="applyVat">Apply Vat</label>
               <div class="p-field p-col-12 p-md-1">
                 <InputSwitch v-model="applyVat"/>
               </div>
             </div>
             <div class="p-field p-col-12 p-md-2">
               <label for="extraExpensesAmt">Amount</label>
               <InputText v-model="extraExpenseAmt" id="extraExpensesAmt"/>
             </div>

              <div class="p-field p-col-12 p-md-2">
               <label for="applyVat">Apply On Bill</label>
             </div>
              <div class="p-field p-col-12 p-md-1">
               <InputSwitch v-model="applyExpensesOnBill"/>
             </div>
             <div class="p-field p-col-12 p-md-1 p-mt-5">
               <Button class="p-button-raised p-button-rounded"
               @click.prevent="addExtraExpensesToList" :label="!editExtraExpenses?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
               <Button class="p-button-raised p-button-danger"
                v-if="editExtraExpenses" @click.prevent="cancelExtraExpenses" label="Cancel"/>
             </div>
           </div>
          </form>
          <table class="table table-bordered" style="margin-top: 2em;border: 1px solid #c8c8c8;">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Expenses Name</th>
                <th>Apply Vat</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-for="(expense,index) in inventoryExtraExpensesList" :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{expense.extraExpense.expensesName}}</td>
                <td>{{expense.applyVat?'Yes':'No'}}</td>
                <td>{{expense.extraExpenseAmt}}</td>
                <td>
                  <Button class="p-button-raised p-button-success"
                  @click.prevent="editExtraExpensesDto(expense,index)"
                  icon="pi pi-pencil"/>
                  <Button class="p-button-raised p-button-danger"
                  v-if="editExtraExpenses"
                  @click.prevent="removeExtraExpense(expense, index)" disabled icon="pi pi-trash"/>
                  <Button class="p-button-raised p-button-danger" v-else @click.prevent="removeExtraExpense(expense, index)"
                  icon="pi pi-trash"/>
                </td>
              </tr>
            </tbody>
          </table>
        <template #footer>
            <Button class="p-button-raised p-button-rounded" @click.prevent="closeBasic" label="Save"/>
            <Button @click.prevent="closeBasic" class="p-button-raised p-button-danger"
            label="Cancel"/>
        </template>
        </Dialog>
       </form>
      </div> -->
     </div>
     <div class="p-fluid p-formgrid p-grid">
         <div class="p-field p-col-12 p-md-6"></div>
         <div class="p-field p-col-12 p-md-1">
          <Button icon="pi pi-save" class="p-button-raised p-button-success"
          @click="addPurchaseInvoice"
          :label="purchaseInvoice === undefined ? 'Save': 'Update'"/>
         </div>
         <div class="p-field p-col-12 p-md-1" v-if="purchaseInvoice ==undefined">
          <Button class="p-button-raised p-button-warning" @click="reset" label="Reset" icon="pi pi-refresh"/>
         </div>
         <div class="p-field p-col-12 p-md-1" v-if="purchaseInvoice!=undefined">
          <Button class="p-button-raised p-button-danger" @click="goBack()" label="Cancel"/>
         </div>
         <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
        </div>
        <div class="p-field p-col-12 p-md-2" >
          <Button icon="pi pi-download" v-if="saved" label="Generate PDF" class="p-button-raised p-button-secondary"
            @click="printBill"/>
            <Button icon="pi pi-download" v-else disabled label="Generate PDF" class="p-button-raised p-button-secondary"
              @click="printBill"/>
         </div>
        </div>
      </div>
       <Dialog header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}">
          <input id="imageUpload" type="file" style="margin-bottom: 2em;" @change="onFileSelect" multiple/>
          <Carousel :value="url" :numVisible="2" :numScroll="2">
            <template #item="slotProps">
              <div class="product-item">
                <div class="product-item-content">
                  <div class="p-mb-3">
                    <img :src="slotProps.data" style="height:250px;width:250px" class="product-image"/>
                  </div>
                  <div>
                    <div class="car-buttons p-mt-5">
                      <Button class="p-button-raised p-button-danger p-mr-2"
                              @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Carousel>
        </Dialog>

         <Dialog header="View Image " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
          <div v-if="this.imageList.length > 0">
            <div class="card">
              <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps">
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="slotProps.data.name" style="height:250px;width:250px" class="product-image"/>
                      </div>
                      <div>
                        <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Carousel>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised p-button-danger" @click.prevent="back" label="Back"/>
          </template>
        </Dialog>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputSwitch from 'primevue/inputswitch'
import Dialog from 'primevue/dialog'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import supplierDialog from '../accountDialog/SupplierAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import extraExpensesDialog from '../billSundryDialog/billSundryPurchaseDialog'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import readXlsxFile from 'read-excel-file'
import Checkbox from 'primevue/checkbox'
import Carousel from 'primevue/carousel'

export default {
  name: 'purchaseInvoice',
  props: ['purchaseInvoice'],
  data() {
    return {
      name: '',
      warehouse: '',
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      items: '',
      accountMaster: '',
      cashTransactionMaster: '',
      showItemUploadDialog: false,
      openImageViewer: false,
      quantity: 0,
      rate: 0,
      purchaseSalesDate: null,
      manufactureDate: null,
      dairyManualEntry: false,
      expiryDate: null,
      transactionDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      inventoryExtraExpensesList: [],
      inventoryExtraExpensesDeletedList: [],
      images: [],
      url: [],
      deletedImage: [],
      imageList: [],
      supplierType: '',
      shift: '',
      supplierTypeList: [{label: 'Kishan', value: 'Kishan'}, {label: 'Sanstha', value: 'Sanstha'}],
      shiftList: [{label: 'Morning', value: 'Morning'}, {label: 'Evening', value: 'Evening'}],
      taxType: '',
      taxable: 0,
      tax: 0,
      nonTaxable: 0,
      vatPercentage: '',
      purchaseMessage: '',
      editing: false,
      billNo: null,
      index: null,
      inventoryHeaderId: null,
      id: null,
      editDTO: false,
      refNo: null,
      loading: false,
      itemSelected: '',
      totalQty: 0,
      total: 0,
      extraExpensesList: null,
      accountMasterListForExtraExpenses: [],
      customerAccountList: [],
      applyExpensesOnBill: false,
      discountPer: 0,
      exciseDuty: 0.0,
      discountAmt: 0,
      exciseChargeAmount: 0.0,
      displayBasic: false,
      displayBasicBatchDetails: false,
      extraExpenses: '',
      applyVat: false,
      editExtraExpenses: false,
      filteredItems: null,
      printDialog: false,
      headerId: null,
      saved: false,
      disableDeleteBtn: false,
      extraExpenseAmt: 0,
      englishDateEnabled: true,
      narration: '',
      loadFromOrder: false,
      loadFromChallan: false,
      loadType: '',
      orderIdList: [],
      orderId: null,
      challanId: null,
      challanIdList: [],
      setWarehouseData: false,
      chooseDiscountPer: false,
      chooseDiscountAmt: true,
      waterMixPercentage: 0.0,
      perFATPercentage: 0.0,
      perSnfPercentage: 0.0,
      fatPercentage: 0.0,
      fatAmount: 0.0,
      snfPercentage: 0.0,
      tsPercentage: 0.0,
      snfAmount: 0.0,
      perTsPercentage: 0.0,
      tsAmount: 0.0,
      tsRate: 0.0,
      rateAdjustment: 1.0,
      fatRate: 0.0,
      snfRate: 0.0,
      taxableQty: 0.0,
      nonTaxableQty: 0.0,
      supplierFound: false

    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate)
        if (isNaN(totalAmt)) {
          totalAmt = 0.00
        }
        this.total = totalAmt.toFixed(2)
        return totalAmt
      }
    },
    findCcRate() {
      this.ccRate = 0
      if (this.ccPercentage > 0 && this.rate > 0) {
        let ccR = 0.0
        ccR = parseFloat(this.rate) * parseFloat(this.ccPercentage) / 100
        if (isNaN(ccR)) {
          ccR = 0.00
        }
        this.ccRate = ccR.toFixed(2)
        return ccR
      }
    },
    findRate() {
      if (this.rate === 0) {
        if (this.total > 0 && this.quantity > 0) {
          // eslint-disable-next-line no-unused-vars
          let rates = 0
          rates = parseFloat(this.total) / parseFloat(this.quantity)
          if (isNaN(rates)) {
            rates = 0.00
          }
          this.rate = rates.toFixed(2)
          return rates
        }
      }
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.purchaseRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      let discountPerItem = 0
      let totalDiscountPerItem = 0
      // this.discountAmt = 0
      this.exciseChargeAmount = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.taxableQty = 0.0
      this.nonTaxableQty = 0.0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].ccPercentage) / 100) * this.inventoryInOutDetailList[i].freeQty
        console.log()
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
        if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
          this.totalQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
        }
        if (this.chooseDiscountPer === true) {
          if (this.discountPer > 100) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Discount must be less than 100 %', life: 10000})
            return
          }
          // this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
          if (this.discountAmt === '') {
            this.discountAmt = 0
          }
          this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100)
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt === '') {
            this.discountAmt = 0.0
          }
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }

        switch (this.taxType) {
          case 'Exclusive':
            if (this.itemSelected.vatable) {
              this.tax = 0
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              // this.taxable = subTotal - parseFloat(totalDiscountPerItem)
              this.taxable = subTotal
              this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
              if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
                this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
              }
              if (this.exciseDutyCal > 0) {
                this.exciseChargeAmount = this.exciseDutyCal
              }
              this.tax += parseFloat(this.taxable * 0.13)
              this.addExtraExpenses()
            } else {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - parseFloat(totalDiscountPerItem))
              this.addExtraExpenses()
            }
            break
          case 'Inclusive':
            if (this.itemSelected.vatable) {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              // subTotal = parseFloat(subTotal) - parseFloat(totalDiscountPerItem)
              subTotal = parseFloat(subTotal)
              let amtWithoutVat = ((parseFloat(subTotal * 100)) / (parseFloat(100 + 13))).toFixed(4)
              this.taxable += (parseFloat(amtWithoutVat))
              this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
              if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
                this.taxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
              }
              if (this.exciseDutyCal > 0) {
                this.exciseChargeAmount = this.exciseDutyCal
              }
              this.tax += (parseFloat(subTotal) - parseFloat(amtWithoutVat))
              this.addExtraExpenses()
            } else {
              // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - totalDiscountPerItem)
              this.addExtraExpenses()
            }
            break
          case 'Exempt':
            // totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
            this.nonTaxable += ((parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)) - totalDiscountPerItem)
            this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].ccPercentage) / 100) * this.inventoryInOutDetailList[i].freeQty
            this.nonTaxableQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
            if (this.inventoryInOutDetailList[i].ccPercentage > 0) {
              this.nonTaxableQty += parseFloat(this.inventoryInOutDetailList[i].freeQty)
            }
            break
        }
      }
      if (this.discountAmt > subTotal) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Discount Amount must be less than total Amount!',
          life: 10000
        })
        return
      }
      this.nonTaxable -= parseFloat(discountPerItem) * this.nonTaxableQty
      this.taxable -= parseFloat(discountPerItem) * this.taxableQty
      return subTotal
    },
    exciseDutyCal () {
      let exc = 0.0
      if (this.exciseDuty === '') {
        this.exciseDuty = 0
      }
      exc = this.taxable = parseFloat(this.taxable) + parseFloat(this.exciseDuty)
      return exc
    },
    totalBillAmount () {
      let totalBillAmount = 0.0
      totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
      return totalBillAmount
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerCashList()
    this.customerSupplierList()
    this.maxPurchaseBillNo()
    this.extraPurchaseExpenses()
    this.itemMasterListByItemTypes()
    this.accountMasterForExtraExpenses()
    if (this.purchaseInvoice !== undefined) {
      this.editPurchase()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.purchaseInvoice === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    addExtraExpenses() {
      if (this.inventoryExtraExpensesList.length > 0 & this.applyExpensesOnBill) {
        for (let i = 0; i < this.inventoryExtraExpensesList.length; i++) {
          if (this.inventoryExtraExpensesList[i].applyVat) {
            this.taxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          } else {
            this.nonTaxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          }
        }
      }
    },
    async customerSupplierList () {
      let response = await this.$store.dispatch('loadsupplierAndCustomerList')
      if (response.data.status === 'SUCCESS') {
        this.customerAccountList = response.data.data
      }
    },
    async accountMasterForExtraExpenses() {
      let response = await this.$store.dispatch('loadOfficeAccountListForDropdown')
      this.accountMasterForExtraExpenses = response.data.data
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerCashList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemType')
    },
    async extraPurchaseExpenses() {
      let resp = await this.$store.dispatch('extraPurchaseExpenses')
      this.extraExpensesList = resp.data.data
    },
    async maxPurchaseBillNo() {
      let response = await this.$store.dispatch('maxPurchaseBillNo')
      if (this.purchaseInvoice === undefined) {
        this.billNo = response.data.data
        this.purchaseMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.billNo = this.purchaseInvoice.edit.billNo
        this.purchaseMessage = this.purchaseInvoice.edit.remarks
      }
    },
    addItemToDTOList() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        unitName: this.items.unitName,
        id: this.id,
        waterMixPercentage: this.waterMixPercentage,
        perFATPercentage: this.perFATPercentage,
        perSnfPercentage: this.perSnfPercentage,
        fatPercentage: this.fatPercentage,
        fatAmount: this.fatAmount,
        snfPercentage: this.snfPercentage,
        snfAmount: this.snfAmount,
        tsPercentage: this.tsPercentage,
        perTsPercentage: this.perTsPercentage,
        tsAmount: this.tsAmount,
        rateAdjustment: this.rateAdjustment,
        fatRate: this.fatRate,
        snfRate: this.snfRate
        // dairyPurchaseDetailsDTOList: this.
      }
      console.log(item)
      if (this.taxType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select purchase type!', life: 10000})
        return
      }
      // if (this.accountMaster === '') {
      //   this.$toast.add({severity: 'error', summary: '', detail: 'Please select vendor!', life: 10000})
      //   return
      // }
      if (this.warehouse === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      }
      // } else if (this.quantity <= 0) {
      //   this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
      //   return
      // } else if (this.rate <= 0) {
      //   this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
      //   return
      // } else {
      if (this.dairyManualEntry) {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    async editItemFromDTO(item, index) {
      this.itemDTOreset()
      this.disableDeleteBtn = true
      this.items = item.itemMaster
      this.rate = item.rate
      this.quantity = item.quantity
      this.waterMixPercentage = item.waterMixPercentage
      this.perFATPercentage = item.perFATPercentage
      this.perSnfPercentage = item.perSnfPercentage
      this.fatPercentage = item.fatPercentage
      this.fatAmount = item.fatAmount
      this.snfPercentage = item.snfPercentage
      this.snfAmount = item.snfAmount
      this.tsPercentage = item.tsPercentage
      this.perTsPercentage = item.perTsPercentage
      this.tsAmount = item.tsAmount
      this.rateAdjustment = item.rateAdjustment
      this.fatRate = item.fatRate
      this.snfRate = item.snfRate
      this.total = (parseFloat(item.rate) * parseFloat(item.quantity)).toFixed(2)
      this.editDTO = true
      this.index = index
      if (item.id !== undefined) {
        this.id = item.id
      }
      // // debugger
    },
    addJsonFile() {
    },
    addExtraExpensesToList() {
      if (this.extraExpenses === null || this.extraExpenses === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Extra Expenses!', life: 10000})
        return
      }
      if (this.extraExpenseAmt < 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Enter VAT amount!', life: 10000})
        return
      }
      let extraExpense = {
        extraExpense: this.extraExpenses,
        id: this.extraExpenses.id,
        extraExpenseAmt: this.extraExpenseAmt,
        applyVat: this.applyVat
      }
      if (!this.editExtraExpenses) {
        this.inventoryExtraExpensesList.push({...extraExpense})
      } else {
        this.inventoryExtraExpensesList.splice(this.index, 1, {...extraExpense})
      }
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    editExtraExpensesDto(data, index) {
      this.resetExtraExpenses()
      this.extraExpenses = data.extraExpense
      this.editExtraExpenses = true
      this.index = index
      this.applyVat = data.applyVat
      this.extraExpenseAmt = data.extraExpenseAmt
      if (data.extraExpense.id != null) {
        this.id = data.extraExpense.id
      }
    },
    removeExtraExpense(data, index) {
      if (this.editing) {
        this.inventoryExtraExpensesDeletedList.push({...data})
      }
      this.inventoryExtraExpensesList.splice(index, 1)
    },
    cancelExtraExpenses() {
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    async addPurchaseInvoice() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter Purchase date!', life: 10000})
        return
      }
      let response = ''
      if (this.cashTransactionMaster === undefined) {
        this.cashTransactionMaster == null
      }
      if (this.discountPer > 100) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Discount percentage cannot be greater than 100!', life: 10000})
        return
      }

      let purchaseInvoice = {
        billNo: this.billNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        transactionDate: this.transactionDate,
        transactionDateNepali: this.transactionDate,
        referenceNumber: this.refNo,
        fiscalYearId: this.$store.state.fyId,
        taxType: this.taxType,
        remarks: this.narration,
        discountPercentage: this.discountPer,
        discount: this.discountAmt,
        exciseChargeAmount: this.exciseDuty,
        subTotalAmount: this.subTotal,
        totalBillAmount: this.totalBillAmount,
        cashTransactionId: this.cashTransactionMaster.id,
        applyExpensesOnBill: this.applyExpensesOnBill,
        // inventoryHeaderId: this.inventoryHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
        inventoryExtraExpensesList: this.inventoryExtraExpensesList,
        sumOfQuantity: this.totalQty,
        supplierType: this.supplierType,
        shift: this.shift
      }
      const formData = new FormData()
      formData.append('purchaseInvoice', JSON.stringify(purchaseInvoice))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      // // debugger
      if (purchaseInvoice.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item !', life: 10000})
        return
      }
      if (this.purchaseInvoice === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addPurchaseDairyInvoice', formData)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePurchaseInvoice', formData)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        // this.$emit('update-message', response.data.message)
        await this.maxPurchaseBillNo()
        this.supplierCustomerCashList()
        this.customerSupplierList()
        this.itemMasterListByItemTypes()
        // if (!this.editing && response.data.data.id > 0) {
        //   this.openPrintDialog(response.data.data.id)
        // }
        this.reset()
        // this.focusAfterSave()
        this.saved = true
        this.headerId = response.data.data.id
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    set_data_warehouse(data) {
      let warehouse = {
        id: data.id,
        name: data.name
      }
      this.warehouse = warehouse
      this.warehouseList()
    },
    set_data_item(data) {
      this.items = data
      this.itemMasterListByItemTypes()
    },
    set_supplier_master(data) {
      this.supplierCustomerList()
      this.accountMasterId = data
    },
    async editPurchase() {
      this.editing = true
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.purchaseInvoice.edit.purchaseSalesDateNepali
        this.transactionDate = this.purchaseInvoice.edit.transactionDateNepali
        this.manufactureDate = this.purchaseInvoice.edit.manufactureDateNepali
        this.expiryDate = this.purchaseInvoice.edit.expiryDateNepali
      } else {
        this.purchaseSalesDate = this.purchaseInvoice.edit.purchaseDate
        this.transactionDate = this.purchaseInvoice.edit.transactionDate
        this.manufactureDate = this.purchaseInvoice.edit.manufactureDate
        this.expiryDate = this.purchaseInvoice.edit.expiryDate
      }
      this.refNo = this.purchaseInvoice.edit.referenceNumber
      this.taxType = this.purchaseInvoice.edit.vatTypeEnum
      this.warehouse = this.purchaseInvoice.edit.warehouse
      this.narration = this.purchaseInvoice.edit.remarks
      this.discountPer = this.purchaseInvoice.edit.discountPercentage
      this.discountAmt = this.purchaseInvoice.edit.discount
      this.exciseDuty = this.purchaseInvoice.edit.exciseChargeAmount
      this.accountMaster = this.purchaseInvoice.edit.accountMaster
      this.cashTransactionMaster = this.purchaseInvoice.edit.cashTransactionMaster
      this.inventoryHeaderId = this.purchaseInvoice.edit.id
      this.inventoryInOutDetailList = this.purchaseInvoice.edit.inventoryInOutDetailList
      this.inventoryExtraExpensesList = this.purchaseInvoice.edit.inventoryExtraExpensesListForReport
      // // debugger
    },
    removeItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        // // debugger
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      // // debugger
      this.inventoryInOutDetailList.splice(id, 1)
    },
    goBack() {
      // // eslint-disable-next-line no-return-assign
      // this.inventoryInOutDetailList.forEach(data => this.id = data.id)
      // if (this.id !== null) {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.purchaseInvoice.edit.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
        // // debugger
        // }
      }
      this.$router.back()
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.itemSelected = ''
      this.id = null
      this.disableDeleteBtn = false
      this.resetDairyValues()
    },
    reset() {
      // window.location.reload()
      this.itemDTOreset()
      this.discountPer = 0
      this.warehouse = ''
      this.accountMaster = ''
      this.referenceNumber = ''
      this.supplierType = ''
      this.shift = ''
      this.exciseDuty = 0.0
      this.discountPer = 0
      this.discountAmt = 0
      this.inventoryInOutDetailList = []
      this.refNo = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
        this.transactionDate = new Date().toISOString().slice(0, 10)
      }
      this.taxType = ''
      this.inventoryExtraExpensesList = []
      this.images = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.purchaseInvoice === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    openBasic() {
      this.displayBasic = true
    },
    openBasicBatchDetails() {
      // this.ccRate = this.rate * this.ccPercentage / 100
      this.displayBasicBatchDetails = true
    },
    closeBasic() {
      this.displayBasic = false
      this.editExtraExpenses = false
    },
    closeBasicBatchDetails() {
      this.displayBasicBatchDetails = false
      this.editExtraExpenses = false
      // this.findCcRate()
    },
    resetExtraExpenses() {
      this.extraExpenses = ''
      this.applyVat = false
      this.extraExpenseAmt = ''
    },
    setNepaliDate() {
      if (this.purchaseInvoice === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        this.transactionDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
      $('#transactionDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.transactionDate = $('#transactionDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.manufactureDate = new Date().toISOString().slice(0, 10)
      this.expiryDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    openPrintDialog (data) {
      this.printDialog = true
      this.headerId = data
    },
    printBill() {
      let purchaseInvoice = {
        id: this.headerId,
        type: 'printPurchaseBill',
        report: 'PurchaseInvoice'
      }
      this.printDialog = false
      this.$store.dispatch('exportToPdf', purchaseInvoice)
      this.focusAfterSave()
      this.saved = false
    },
    closePrintDialog() {
      this.printDialog = false
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouse = this.$store.state.warehouseData
        // // debugger
      } else if (this.warehouseLists.length === 1) {
        this.warehouse = this.warehouseLists[0]
      }
    },
    async loadFrom(data) {
      if (data === 'order') {
        let orderIds = await this.$store.dispatch('loadOrderIdList')
        this.orderIdList = orderIds.data.data
        // // debugger
        this.loadFromOrder = true
        this.loadFromChallan = false
      }
      if (data === 'challan') {
        let challanIds = await this.$store.dispatch('challanIdList')
        this.challanIdList = challanIds.data.data
        this.loadFromChallan = true
        this.loadFromOrder = false
      }
    },
    async loadPurchaseDataWithOrderId(order) {
      let response = await this.$store.dispatch('loadDataWithOrderId', order)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseSalesDateNepali
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.narration = data.remarks
          this.refNo = data.referenceNumber
          this.warehouse = data.warehouse
          this.accountMaster = data.accountMaster
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    },
    async loadPurchaseDataWithChallanId(challan) {
      let response = await this.$store.dispatch('loadDataWithPurchaseChallanNo', challan)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseDate
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.narration = data.remarks
          this.refNo = data.referenceNumber
          this.warehouse = data.warehouse
          this.accountMaster = data.warehouse
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    },
    async onFileChange(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null
      readXlsxFile(xlsxfile).then((rows) => {
        rows.forEach(data => {
          if (data[1] !== 'Suppliers') {
            let ft = (parseFloat(data[5]) * parseFloat(data[7]))
            this.fatAmount = ft.toFixed(4)
            let fn = (parseFloat(data[6]) * parseFloat(data[8]))
            this.snfAmount = fn.toFixed(4)
            let rat = (parseFloat(data[5]) * parseFloat(data[7])) + (parseFloat(data[6]) * parseFloat(data[8])) + data[9]
            this.rate = rat.toFixed(4)
            let item = {
              itemId: this.items.id,
              itemMaster: this.items,
              quantity: data[4],
              unitName: this.items.unitName,
              id: this.id,
              supplierName: data[1],
              address: data[2],
              contact: data[3],
              fatPercentage: data[5],
              snfPercentage: data[6],
              rateAdjustment: data[9],
              rate: this.rate,
              fatAmount: this.fatAmount,
              snfAmount: this.snfAmount
            }
            // let supplier = {
            //   name: data[4]
            // }
            // let resp = await this.$store.dispatch('loadSupplierByName', supplier)
            // if (resp.data.data.length <= 0) {
            //   this.$toast.add({severity: 'error', summary: '', detail: 'Please create supplier of name.' + data[4], life: 10000})
            //   return
            // }
            if (!this.editDTO) {
              this.inventoryInOutDetailList.push({...item})
            } else {
              this.inventoryInOutDetailList.splice(this.index, 1, {...item})
            }
          }
        })
      })
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    onFileChangeSanstha(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null
      readXlsxFile(xlsxfile).then((rows) => {
        // console.log('rows:', rows)
        // // debugger
        rows.forEach(data => {
          // this.findRate(data)
          // this.findFnfAmount(data)
          if (data[1] !== 'Suppliers') {
            let ft = (parseFloat(data[5]) * parseFloat(data[7]))
            this.fatAmount = ft.toFixed(4)
            let fn = (parseFloat(data[6]) * parseFloat(data[8]))
            this.snfAmount = fn.toFixed(4)
            let ts = (parseFloat(data[5]) + parseFloat(data[6])) * parseFloat(data[9])
            this.tsAmount = ts.toFixed(4)
            let rat = (parseFloat(data[5]) * parseFloat(data[7])) + (parseFloat(data[6]) * parseFloat(data[8])) + data[10] + parseFloat(this.tsAmount)
            this.rate = rat.toFixed(4)
          // // debugger
          // this.findFatAmount(data)
          // // debugger
            let item = {
              itemId: this.items.id,
              itemMaster: this.items,
              quantity: data[4],
              unitName: this.items.unitName,
              id: this.id,
              supplierName: data[1],
              address: data[2],
              contact: data[3],
            // waterMixPercentage: data[5],
              fatPercentage: data[5],
              snfPercentage: data[6],
              rateAdjustment: data[10],
              tsPercentage: data[9],
              tsAmount: this.tsAmount,
              rate: this.rate,
              fatAmount: this.fatAmount,
              snfAmount: this.snfAmount
            // snfPercentage: data.snfPercentage,

            // perTsPercentage: data.perTsPercentage
            }
          // // debugger
            // let supplier = {
            //   name: data[1]
            // }
            // let resp = await this.$store.dispatch('loadSupplierByName', supplier)
            // this.findSuuplier(supplier)
            // if (!this.supplierFound) {
            //   this.$toast.add({severity: 'error', summary: '', detail: 'Please create supplier of name.' + data[1], life: 10000})
            //   return
            // }
            if (!this.editDTO) {
              this.inventoryInOutDetailList.push({...item})
            } else {
              this.inventoryInOutDetailList.splice(this.index, 1, {...item})
            }
          }
        })
        // // debugger
      })
      // this.inventoryInOutDetailList.splice(1, 1)
    },
    async findSuuplier(supplier) {
      let resp = await this.$store.dispatch('loadSupplierByName', supplier)
      // debugger
      if (resp.data.data.length > 0) {
        this.supplierFound = true
      }
    },
    findRate(data) {
      let rat = (parseFloat(data[5]) * 7.11) + parseFloat(data[6]) * (3.91 + 1)
      this.rate = rat
    },
    findFatAmount(data) {
      let fn = (parseFloat(data[5]) * 7.11) * parseFloat(data[5])
      this.fatAmount = fn
    },
    findFnfAmount(data) {
      let s = (parseFloat(data[5]) * 7.11) * parseFloat(data[5])
      this.findFnfAmount = s
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        let fileExtension = f.name.split('.').pop()
        console.log(fileExtension)
        if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'JPG') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 10000})
          return
        }
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
          // console.log(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    },
    resetDairyValues() {
      this.waterMixPercentage = 0.0
      this.perFATPercentage = 0.0
      this.perSnfPercentage = 0.0
      this.fatPercentage = 0.0
      this.fatAmount = 0.0
      this.snfPercentage = 0.0
      this.snfAmount = 0.0
      this.tsPercentage = 0.0
      this.perTsPercentage = 0.0
      this.tsAmount = 0.0
      this.rateAdjustment = 0.0
      this.fatRate = 0.0
      this.snfRate = 0.0
      this.taxableQty = 0.0
      this.nonTaxableQty = 0.0
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputSwitch,
    Dialog,
    AutoComplete,
    InputNumber,
    InputMask,
    supplierDialog,
    wearhouseDialog,
    itemDialog,
    extraExpensesDialog,
    RadioButton,
    Button,
    Carousel,
    Textarea,
    readXlsxFile,
    Checkbox
  }
}
</script>

<style scoped  src="@../../../static/css/purchase.css" >
</style>



// WEBPACK FOOTER //
// dairyPurchaseInvoice.vue?6ac53be8